module.exports = __webpack_public_path__ + "img/diversos-icon.8414727b.svg";